import React from "react";
import { auth, provider, signInWithPopup } from "./firebase";
import api from "./api";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function UserLanding() {
  const navigate = useNavigate();

  const handleLogin = async (type) => {
    try {
      const result = await signInWithPopup(auth, provider);
      const userEmail = result.user.email;

      if (type === "new") {
        navigate("/register", { state: { email: userEmail } });
      } else {
        const res = await api.post("/check-user", {
          email: userEmail,
        });

        if (res.data.registered) {
          navigate("/profile", { state: { user: res.data.user } });
        } else {
          navigate("/register", { state: { email: userEmail } });
        }
      }
    } catch (err) {
      console.error("Google login error:", err);
    }
  };

  return (
    <div className="user-landing-container">
      <div className="user-landing-box">
        <h2 className="user-landing-title">Welcome to College Fest</h2>
        <p className="user-landing-subtitle">Please continue with your Google account</p>
        <div className="user-landing-buttons">
          <button
            className="user-landing-button green"
            onClick={() => handleLogin("new")}
          >
            New Registration
          </button>
          <button
            className="user-landing-button blue"
            onClick={() => handleLogin("existing")}
          >
            Already Registered
          </button>
        </div>
      </div>
    </div>
  );
}
